export function clone(v) {
  return JSON.parse(JSON.stringify(v));
}
